<template>
  <div>
    <img src="@/assets/heyitsme-icon.svg" class="back-btn-absolute" @click="$router.push('/')" alt="Home" role="button" />
    <h1 class="about-title">About Me</h1>
    <div class="about-page">
      <div class="about-images">
        <img src="@/assets/about_me.png" alt="Katy" class="about-image" />
      </div>
      <div class="about-content">
        <p>
          I'm Katy, the founder of GoBeyond Software Development and the creator of Hey, It's Me. I was a Software Engineer and Product Manager before becoming a stay-at-home mom back in 2020. Now, I work solo to build tools that help people connect with themselves in meaningful ways.
          <br>
          <br>
          Since becoming a mom, I've worked hard to heal past wounds and learn how to show up for myself and my kids in ways that make me feel proud.
        </p>
        <p>
          I created Hey, It's Me to help turn the things I learn into true and lasting change. It's become my dedicated space for key ideas, takeaways, and affirmations that take consistent reminders to become habits. And, as a stay-at-home mom, receiving a message (even from myself) brightens up my day and helps me feel less lonely. 
        </p>
        <p>
          I also love to sew and play chess. If you do too, <router-link to="/contact" style="color: #7da47e; text-decoration: none; cursor: pointer;">reach out</router-link>! I'll always welcome a new chess opponent. 
        </p>
        <p>
          As a solo developer, I handle everything that goes into designing, creating, and maintaining Hey, It's Me. If you like using Hey, It's Me and want to contribute toward the cost of keeping it running, <a href="https://buy.stripe.com/14A28r9XObsObx3bwh28800" target="_blank" style="color: #7da47e; text-decoration: none; cursor: pointer;">you can do so here.</a> 
        </p>
        <p>
          If you have any questions or would like to say hello, don't hesitate to contact me.
        </p>
        <h1 class="about-title" style="text-align:center">
          ~ Katy
        </h1>
      </div>
    </div>
  </div>
</template>

<script setup>
// About Me page component - information about the creator
// Uses Composition API for consistency with other components
</script>

<style scoped>
.back-btn-absolute {
  position: absolute;
  top: 18px;
  left: 28px;
  z-index: 1000;
  width: 88px;
  height: 88px;
  object-fit: contain;
  cursor: pointer;
  transition: opacity 0.2s;
}
.back-btn-absolute:hover {
  opacity: 0.75;
}
@media (max-width: 700px) {
  .back-btn-absolute {
    top: 8px;
    left: 14px;
    width: 68px;
    height: 68px;
  }
}
.about-page {
  max-width: 700px;
  margin: 8px auto 32px auto;
  padding: 24px 32px;
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  text-align: left;
  display: flex;
  gap: 24px;
  align-items: flex-start;
}
@media (max-width: 700px) {
  .about-page {
    max-width: 98vw;
    padding: 12px 10vw;
    flex-direction: column;
  }
}
.about-images {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-shrink: 0;
  align-items: center;
}
.about-image {
  width: 200px;
  height: auto;
  border-radius: 8px;
}
.donate-image {
  width: 100px;
  height: auto;
  cursor: pointer;
}
@media (max-width: 700px) {
  .about-images {
    width: 100%;
    align-items: center;
  }
  .about-image {
    width: 100%;
    max-width: 300px;
  }
  .donate-image {
    width: 100%;
    max-width: 300px;
  }
}
.about-title {
  text-align: center;
  font-family: 'StayWonderful', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-size: 2.5rem;
  color: #312d30;
  margin-bottom: 32px;
  font-weight: 300;
}
.about-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.about-content p {
  font-family: 'Quicksand', 'Segoe UI', 'Georgia', serif;
  font-size: .90rem;
  color: #312d30;
  margin: 0;
}
</style>
